import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { ShareViewerDialogComponent } from './share-viewer-dialog/share-viewer-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, take } from 'rxjs';
import { AuthenticatedUserService } from '@tailormap-viewer/api';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';
import { TooltipDirective } from '@tailormap-viewer/shared';

@Component({
    selector: 'tm-share-viewer',
    templateUrl: './share-viewer.component.html',
    styleUrls: ['./share-viewer.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatButton,
        TooltipDirective,
        MatIcon,
        AsyncPipe,
    ],
})
export class ShareViewerComponent {
  private dialog = inject(MatDialog);
  private cdr = inject(ChangeDetectorRef);
  private authenticatedUserService = inject(AuthenticatedUserService);


  public toolActive = false;
  private dialogRef: MatDialogRef<ShareViewerDialogComponent, any> | undefined;

  public userIsAdmin$: Observable<boolean>;

  constructor() {
    this.userIsAdmin$ = this.authenticatedUserService.isAdminUser$();
  }

  public toggle() {
    this.toolActive = !this.toolActive;
    if (this.toolActive) {
      this.dialogRef = this.dialog.open(ShareViewerDialogComponent, {
        width: 'calc(60 * var(--vw))',
      });
      this.dialogRef.afterClosed()
        .pipe(take(1))
        .subscribe(() => {
          this.dialogRef = undefined;
          this.toolActive = false;
          this.cdr.detectChanges();
        });
    } else if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = undefined;
    }
  }
}
